import { render, staticRenderFns } from "./CompaniesByGroup.vue?vue&type=template&id=0126afbe&scoped=true&"
import script from "./CompaniesByGroup.vue?vue&type=script&lang=js&"
export * from "./CompaniesByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0126afbe",
  null
  
)

export default component.exports